<template>
  <div class="bubble-wrapper">
    <div class="bubble">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VSpeechBubble'
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/modules/colors';

.bubble-wrapper {
  width: 100%;
  height: auto;
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  z-index: 1;
  box-sizing: border-box;
  padding: 0 36px 0 36px;

  .bubble {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: auto;
    background-color: $orange;
    border-radius: 30px;
    box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.15);
    padding: 10px 15px 9px 15px;

    &:before {
      position: absolute;
      left: 50%;
      top: 0;

      width: 0px;
      height: 0px;
      border-left: 14px solid transparent;
      border-right: 14px solid transparent;
      border-bottom: 20px solid $orange;
      content: '';
      transform: translate(-50%, -50%);
    }
  }
}
</style>